import { useTranslation } from "next-i18next";
import parse from "html-react-parser";
import Accordion from "../../components/v2/accordion/accordion";
import Card from "../../components/v2/cards/card";
import PlatformFeatures from "../../components/v2/common/platform-feature";
import PlatformHeroSection from "../../components/v2/common/platform-hero";
import {
    MwSmallIcon
} from "../../components/v2/icons";
import ProductResources from "../../components/v2/product/product-resource";
import '../../styles/scss/_faq-section.module.scss';

export default function continuousProfiler() {
    const { t } = useTranslation("common");
    const featuresData = t('product.continuous-profiler.features.detailedFeatures', { returnObjects: true }) as any[]
    const features = Array.isArray(featuresData) ? featuresData : []

    const faqsData = t('product.continuous-profiler.faq.questions', { returnObjects: true }) as any[]
    const faqs = Array.isArray(faqsData) ? faqsData : []

    const resourceData = t('product.continuous-profiler.resources', { returnObjects: true }) as any[]
    const resource = Array.isArray(resourceData) ? resourceData : []

    const cardWithIconData = t('product.continuous-profiler.cardWithIcon', { returnObjects: true }) as any[]

    const productTourData = t('product.continuous-profiler.productTour', { returnObjects: true }) as any

    const agentIntegrationData = t('product.continuous-profiler.agentIntegration', { returnObjects: true }) as any
    const benefitsSection = t('product.continuous-profiler.section', { returnObjects: true }) as any
    const explicitBenefits = t('product.continuous-profiler.benefits.cards', { returnObjects: true, defaultValue: [] }) as any[]
    const fallbackBenefits = t('product.continuous-profiler.cardWithIcon', { returnObjects: true }) as any[]
    const benefitsCards = Array.isArray(explicitBenefits) && explicitBenefits.length ? explicitBenefits : fallbackBenefits
    const featuresDataDriven = Array.isArray(features) ? (features as any[]) : []

    return (
        <>
            <div className={"platform-main"}>

                <PlatformHeroSection title={<h1>{t('product.continuous-profiler.hero.title')} <br/> <span
                    className={"text-gradient"}> {t('product.continuous-profiler.hero.titleHighlight')} </span></h1>}
                                     img={"/images/platform/Make-Your-Production-Code-Lean-Cost-Effective.png"} imgMobile={"/images/platform/Make-Your-Production-Code-Lean-Cost-Effective-mobile.webp"} preloadImg
                                     imgAlt={t('product.continuous-profiler.hero.imageAlt')}
                                     className={"platform-page"}/>

                <section className={'mw-card platform-inner'}>
                    <div className={'container'}>
                        <div className={'d-flex card-items'}>
                            <div className={'card-item'}>
                                <div className={'section-tag testimonial pd-right'}><MwSmallIcon/> {t('platform.shared.benefitsTag')}</div>
                                <h2>{benefitsSection.title}</h2>
                            </div>
                            {
                                (benefitsCards || []).map((item: any, index: number) => (
                                    <Card key={index}
                                         heading={item.title}
                                         description={item.description}
                                         isHeading={false}/>
                                ))
                            }
                        </div>
                    </div>
                </section>

                <PlatformFeatures
                    title={<h2>{t('product.continuous-profiler.features.title')}</h2>}
                    dataDriven={featuresDataDriven}
                    description={benefitsSection.description}
                />

                <ProductResources resources={resource} title={t('product.shared.resources.title')}/>

                <section className={"faq-section"}>
                    <div className={"container"}>
                        <h2>{t('product.continuous-profiler.faq.title')}</h2>
                        <div className={"faq-item"}>
                            <Accordion faqs={faqs.map(faq => ({
                            ...faq,
                            answerPlain: faq.text,
                            text:
                                faq.textHtml != null && faq.textHtml !== ""
                                    ? parse(faq.textHtml)
                                    : <p>{faq.text}</p>
                        }))} showGroups={true}/>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}